import { Exception } from './exception';

export class InvalidComponentException extends Exception {}
